import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IDeleteDocumentsSlice } from '../../interfaces/DeleteDocuments'

const deleteDocumentsSlice = createSlice({
  name: 'deleteDocuments',
  initialState: {
    shouldDeleteDocuments:
      localStorage.getItem('shouldDeleteDocuments') === 'true',
  },
  reducers: {
    setShouldDeleteDocuments: (
      state: IDeleteDocumentsSlice,
      action: PayloadAction<boolean>
    ) => {
      localStorage.setItem('shouldDeleteDocuments', action.payload.toString())

      return {
        shouldDeleteDocuments: action.payload,
      }
    },
  },
})

const { actions, reducer } = deleteDocumentsSlice
export const shouldDeleteDocumentsActions = actions

export default reducer
